import { render, staticRenderFns } from "./cgq.vue?vue&type=template&id=39c0e58a&scoped=true"
import script from "./cgq.vue?vue&type=script&lang=js"
export * from "./cgq.vue?vue&type=script&lang=js"
import style0 from "./cgq.vue?vue&type=style&index=0&id=39c0e58a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39c0e58a",
  null
  
)

export default component.exports